import { PersonAnalysisDiscLabels } from '@aibees/elephant/types/personality-analysis';
import { SxStyleThemeValueFunc } from '@aibees/shared/theme';
import type { ButtonProps } from '@mui/material';

export const colorMap: Record<
  PersonAnalysisDiscLabels,
  {
    backgroundColor: string | SxStyleThemeValueFunc;
    labelColor: string | SxStyleThemeValueFunc;
    color: ButtonProps['color'];
  }
> = {
  [PersonAnalysisDiscLabels.C]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.warning[500],
    color: 'warning',
  },
  [PersonAnalysisDiscLabels.c]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.warning[500],
    color: 'warning',
  },
  [PersonAnalysisDiscLabels.D]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.error[700],
    color: 'error',
  },
  [PersonAnalysisDiscLabels.d]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.error[700],
    color: 'error',
  },
  [PersonAnalysisDiscLabels.I]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.success[700],
    color: 'success',
  },
  [PersonAnalysisDiscLabels.i]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.success[700],
    color: 'success',
  },
  [PersonAnalysisDiscLabels.S]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.primary[600],
    color: 'primary',
  },
  [PersonAnalysisDiscLabels.s]: {
    labelColor: (p) => p.palette.common.white,
    backgroundColor: (p) => p.palette.primary[600],
    color: 'primary',
  },
};
